import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'ngx-form-control',
    templateUrl: './form-control.component.html',
    styleUrls: ['./form-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false
})
export class NgxFormControl {

    /**
     * The icon of the form control.
     */
    @Input() icon: string = null;

    /**
     * The label for the form-control.
     */
    @Input() label: string = null;

    /**
     * If the icon should be reversed.
     */
    @Input() reversed = false;

    /**
     * If the form-control should have bottom margin.
     */
    @Input() grouped = true;

}
